// import components
import LgSublist from "./LgSublist";

// hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";

// data
import menuItems from "../../utils/data/menuItems";

// asset
import itemIcon from "../../assets/img/yallalodo.png";

const LgList = () => {
    const [hide, setHide] = useState(true);
    const [t] = useTranslation("global");
    return (
        <div className="lg-list" onMouseLeave={() => setHide(true)}>
            <div
                className="products-btn nav-btn"
                onMouseEnter={() => setHide(false)}
                onClick={() => setHide(!hide)}
            >
                <div className="products-svg"></div>
                <p>{t("nav.list.products")}</p>
            </div>
            <div className={`lg-nav-over-flow-div ${hide && "hide"}`}>
                <ul
                    className={`lg-dropdown ${hide && "hide"}`}
                    onMouseLeave={() => setHide(true)}
                >
                    {menuItems.map((i) => {
                        return i.subItems.length ? (
                            <li key={i.title} className="lg-item">
                                <div className="list-item-title">
                                    <div className="list-img-text">
                                        <img src={itemIcon} alt={i.title} />
                                        <p> {i.title}</p>
                                    </div>
                                    <div className="arrow-svg"></div>
                                </div>
                                <LgSublist items={i.subItems} />
                            </li>
                        ) : (
                            <li key={i.title} className="lg-item">
                                <div className="list-item-title">
                                    <a href={i.link} className="list-img-text">
                                        <img src={itemIcon} alt={i.title} />
                                        <p> {i.title}</p>
                                    </a>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default LgList;
